module.exports = __webpack_public_path__ + "fonts/Mukta-800-devanagari19.180c88a.woff2";